import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import RouteLoader from "../feature-module/loader/RouteLoader";
import { pagesRoute, posRoutes, publicRoutes } from "./router.link";
import { PrivateRoute } from "./auth";

import PosLayout from "./posLayout";
import AuthPages from "./authPages";
import HeaderLayouts from "./headerLayout";

const AllRoutes = () => {
  return (
    <div>
      <RouteLoader>
      <Routes>
        {/* Redirect root to default shop */}
        <Route path="/" element={<Navigate to="/all/admin-dashboard" replace />} />

        {/* Redirect routes without shopId to default 'all' */}
        <Route path="/admin-dashboard" element={<Navigate to="/all/admin-dashboard" replace />} />
        <Route path="/companies" element={<Navigate to="/all/companies" replace />} />
        <Route path="/suppliers" element={<Navigate to="/all/suppliers" replace />} />
        <Route path="/users" element={<Navigate to="/all/users" replace />} />
        <Route path="/product-list" element={<Navigate to="/all/product-list" replace />} />
        <Route path="/pos" element={<Navigate to="/all/pos" replace />} />

          <Route element={<PrivateRoute><HeaderLayouts /></PrivateRoute>}>
            {publicRoutes.map((route, id) => (
              <Route path={route.path} element={route.element} key={id} />
            ))}
          </Route>
          <Route element={<PrivateRoute><PosLayout /></PrivateRoute>}>
            {posRoutes.map((route, id) => (
              <Route path={route.path} element={route.element} key={id} />
            ))}
          </Route>
        <Route element={<AuthPages />}>
          {pagesRoute.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>
      </Routes>
      </RouteLoader>
    </div>
  );
};
export default AllRoutes;
